import { jsxs, jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
const SvgHeartbeat = (props, ref) => /* @__PURE__ */ jsxs("svg", { viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props, children: [
  /* @__PURE__ */ jsxs("g", { clipPath: "url(#Heartbeat_svg__a)", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        opacity: 0.75,
        d: "M29.562 6.538c-1.956 1.013-3.866 2.497-5.561 4.36C20.635 7.199 16.427 5 12.68 5c-2.464 0-4.623.973-6.243 2.81-4.559 5.173-4.095 14.117 1.034 19.938 6.869 7.793 15.957 16.425 16.047 16.51a.696.696 0 0 0 .959.003c.09-.086 9.091-8.617 16.048-16.513 5.129-5.82 5.593-14.763 1.034-19.937C39.942 5.973 37.783 5 35.32 5c-1.858 0-3.83.54-5.758 1.538Z",
        fill: "#65BFF1"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M26.766 33.291c-.03 0-.064 0-.095-.003a1.339 1.339 0 0 1-1.129-.793l-5.764-13.008-2.38 5.118c-.219.473-.692.774-1.212.774H1.339a1.338 1.338 0 1 1 0-2.677h13.994l3.262-7.017a1.35 1.35 0 0 1 1.225-.775c.524.006 1 .316 1.211.796l5.938 13.397 4.036-6.456a1.34 1.34 0 0 1 1.134-.628h14.524a1.338 1.338 0 1 1 0 2.677H32.881l-4.979 7.965a1.337 1.337 0 0 1-1.134.628l-.002.002Z",
        fill: "#65BFF1",
        opacity: 0.85
      }
    )
  ] }),
  /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "Heartbeat_svg__a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", transform: "translate(0 5)", d: "M0 0h48v39.451H0z" }) }) })
] });
const ForwardRef = forwardRef(SvgHeartbeat);
export {
  ForwardRef as default
};
